<div class="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50">
  <p-toast></p-toast>

  <p-card class="w-full max-w-5xl shadow-4 rounded-2xl bg-white">
    <div class="mb-12">
      <h2 class="text-2xl font-semibold">Sezione Settings</h2>
      <p class="text-sm text-gray-500">Gestisci le funzioni della tua azienda</p>
    </div>

    <form [formGroup]="settingsForm" class="p-fluid space-y-5">

      <div formGroupName="features" class="space-y-4">

        <!-- ALERT TIMER -->
        <div formGroupName="alertTimer">
          <div class="flex items-center">
            <label for="alertTimerToggle" class="block font-bold me-2">Alert Timer</label>
            <p-toggleswitch id="alertTimerToggle" formControlName="enabled"></p-toggleswitch>
          </div>
          <div class="flex items-center mt-2">
            <label for="alertMinutes" class="block font-normal me-2">Minuti</label>
            <p-inputNumber
              id="alertMinutes"
              formControlName="minutes"
              [showButtons]="true"
              size="small"
              buttonLayout="horizontal"
              [inputStyle]="{ width: '4rem' }"
            ></p-inputNumber>
          </div>
        </div>

        <p-divider />

        <!-- AUTOMATIC MESSAGES -->
        <div formGroupName="automaticMessages">
          <div class="flex items-center">
            <label for="autoMsgToggle" class="block font-bold me-2">Messaggi Automatici</label>
            <p-toggleswitch id="autoMsgToggle" formControlName="enabled"></p-toggleswitch>
          </div>
          <small>Abilita invio automatico di messaggi di stato della conversazione.</small>

          <div class="mt-4 space-y-4">

            <div formGroupName="newConversation" class="space-y-1">
              <div class="flex items-center gap-2">
                <p-toggleswitch formControlName="enabled" size="small"></p-toggleswitch>
                <label class="text-sm font-medium">Nuova Conversazione</label>
              </div>
              <textarea pTextarea formControlName="text" class="w-full text-sm" rows="2" autoResize="true"></textarea>
            </div>

            <div formGroupName="assigned" class="space-y-1">
              <div class="flex items-center gap-2">
                <p-toggleswitch formControlName="enabled" size="small"></p-toggleswitch>
                <label class="text-sm font-medium">Assegnazione Operatore</label>
              </div>
              <small class="text-gray-400">Usa <code>&#123;operator_name&#125;</code> per inserire il nome.</small>
              <textarea pTextarea formControlName="text" class="w-full text-sm" rows="2" autoResize="true"></textarea>
            </div>

            <div formGroupName="active" class="space-y-1">
              <div class="flex items-center gap-2">
                <p-toggleswitch formControlName="enabled" size="small"></p-toggleswitch>
                <label class="text-sm font-medium">Operatore Attivo</label>
              </div>
              <small class="text-gray-400">Usa <code>&#123;operator_name&#125;</code> per inserire il nome.</small>
              <textarea pTextarea formControlName="text" class="w-full text-sm" rows="2" autoResize="true"></textarea>
            </div>

            <div formGroupName="closed" class="space-y-1">
              <div class="flex items-center gap-2">
                <p-toggleswitch formControlName="enabled" size="small"></p-toggleswitch>
                <label class="text-sm font-medium">Conversazione Chiusa</label>
              </div>
              <textarea pTextarea formControlName="text" class="w-full text-sm" rows="2" autoResize="true"></textarea>
            </div>

          </div>
        </div>

        <p-divider />

        <!-- REVOKE CONVERSATION -->
        <div formGroupName="revokeConversation">
          <div class="flex items-center">
            <label for="autoRevokeToggle" class="block font-bold me-2">Revoca</label>
            <p-toggleswitch id="autoRevokeToggle" formControlName="enabled"></p-toggleswitch>
          </div>
          <small>Abilita la funzione di revoca all'interno della chat stessa.</small>
        </div>

        <p-divider />

        <!-- TEMPLATE RIAPERTURA -->
        <div>
          <label for="templateName" class="block font-bold mb-2">Template Riapertura WhatsApp</label>
          <input
            pInputText
            id="templateName"
            formControlName="templateName"
            class="w-full"
            placeholder="es. keyconnect_template"
          />
          <small>Nome del template Meta usato per riaprire la sessione WhatsApp.</small>
        </div>

      </div>
    </form>

    <div class="flex justify-end gap-2 mt-6">
      <p-button label="Salva" icon="pi pi-check-circle" size="small" type="submit" (onClick)="save()"/>
    </div>

  </p-card>

  <kc-loader [loading]="loading"></kc-loader>
</div>
